import { render, staticRenderFns } from "./LaudoHistoricoAgricola.vue?vue&type=template&id=361ffbdb&scoped=true&lang=pug"
import script from "./LaudoHistoricoAgricola.vue?vue&type=script&lang=js"
export * from "./LaudoHistoricoAgricola.vue?vue&type=script&lang=js"
import style0 from "./LaudoHistoricoAgricola.vue?vue&type=style&index=0&id=361ffbdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ffbdb",
  null
  
)

export default component.exports